export const SSR_CURRENT_CAPACITY_A = 20;

const round = (value) => Math.round(value * 1000) / 1000;

export const totalCurrent = (specs) =>
  round(
    (Array.isArray(specs) ? specs : []).reduce((sum, spec) => {
      const current = Number(spec?.current);
      return Number.isFinite(current) ? sum + current : sum;
    }, 0),
  );

export const exceedsCapacity = (specs, capacity = SSR_CURRENT_CAPACITY_A) =>
  totalCurrent(specs) > capacity;
